import { useMemo } from 'react';
import { resolveCoPilotTranscriptDisplayTitle } from '@terra/shared-chat-trace';
import { useChatTabsStore } from '../../../store/chatTabsStore';
import { useConversations } from '../../../store/conversations-store';
import { useOptionalTargetId } from '../../../store/projectStore';

export function useCoPilotExportChatTitle(
  threadId?: string,
): string | undefined {
  const targetId = useOptionalTargetId();
  const { conversations } = useConversations({ targetId });
  const tab = useChatTabsStore((state) =>
    state.chatTabs?.find((chatTab) => chatTab.chatId === threadId),
  );

  const titleFromConversation = useMemo(() => {
    if (!threadId) {
      return undefined;
    }
    const title = conversations.find(
      (conversation) => conversation.threadId === threadId,
    )?.title;
    return title ?? undefined;
  }, [conversations, threadId]);

  const resolvedTitle = resolveCoPilotTranscriptDisplayTitle({
    title: tab?.title ?? titleFromConversation,
    linkedObject: tab?.linkedObject,
  });

  return resolvedTitle ?? undefined;
}
